var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "attribute-form" } }, [
    _c("div", { staticClass: "input" }, [
      _c("label", [_vm._v(_vm._s(_vm.$t("settings.label")))]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.form.label,
            expression: "form.label",
          },
        ],
        attrs: { "no-flags": "" },
        domProps: { value: _vm.form.label },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "label", $event.target.value)
            },
            function ($event) {
              return _vm.formatName(_vm.form.label)
            },
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "input" }, [
      _c("label", [_vm._v(_vm._s(_vm.$t("coupon.name")))]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.form.name,
            expression: "form.name",
          },
        ],
        attrs: { "no-flags": "" },
        domProps: { value: _vm.form.name },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "name", $event.target.value)
            },
            function ($event) {
              return _vm.formatName(_vm.form.name)
            },
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "input" },
      [
        _c("label", [_vm._v(_vm._s(_vm.$t("message.type")))]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            ref: "select",
            attrs: { autocomplete: "off" },
            model: {
              value: _vm.form.type,
              callback: function ($$v) {
                _vm.$set(_vm.form, "type", $$v)
              },
              expression: "form.type",
            },
          },
          _vm._l(_vm.types, function (type) {
            return _c(
              "a-select-option",
              { key: type.value, attrs: { value: type.value } },
              [
                _vm._v(
                  "\n                " + _vm._s(type.text) + "\n            "
                ),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.form.type == "dropdown"
      ? _c("div", { staticClass: "input dropdown" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("message.options")))]),
          _vm._v(" "),
          _c("div", { staticClass: "form" }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "margin-bottom": "5px",
                },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.option,
                      expression: "option",
                    },
                  ],
                  attrs: { "no-flags": "" },
                  domProps: { value: _vm.option },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.option = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "center",
                      "align-items": "center",
                      "margin-left": "5px",
                    },
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.addOption()
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "material-icons",
                        staticStyle: { "font-size": "16px" },
                      },
                      [_vm._v(" add ")]
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "options" },
              _vm._l(_vm.form.options, function (option, index) {
                return _c(
                  "a-tag",
                  {
                    key: index,
                    attrs: { closable: true, color: "blue" },
                    on: {
                      close: function ($event) {
                        return _vm.removeOption(index)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(option) +
                        "\n                "
                    ),
                  ]
                )
              }),
              1
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }